import { render, staticRenderFns } from "./CardFeedVideo.vue?vue&type=template&id=2b421f94"
import script from "./CardFeedVideo.vue?vue&type=script&lang=js"
export * from "./CardFeedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports